"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CompetitorSite_1 = require("../model/CompetitorSite");

var CompetitorSiteConverter_1 = require("./CompetitorSiteConverter");
/**
 * Default implementation of competitor site converter.
 *
 * @author Radek Beran
 */


var CompetitorSiteConverterImpl =
/*#__PURE__*/
function (_CompetitorSiteConver) {
  _inherits(CompetitorSiteConverterImpl, _CompetitorSiteConver);

  function CompetitorSiteConverterImpl() {
    _classCallCheck(this, CompetitorSiteConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorSiteConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorSiteConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var sch = CompetitorSite_1.CompetitorSite.schema;
      return new CompetitorSite_1.CompetitorSite(sch.id.valueOf(conversions.documentToClassId(source)), sch.externalId.valueOfField(source), sch.address.valueOfField(source), sch.city.valueOfField(source), sch.companyId.valueOf(conversions.toClassReferenceId(source.companyId)), sch.type.valueOfField(source), sch.formatId.valueOf(conversions.toClassReferenceId(source.formatId)), sch.active.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return Object.assign({
        externalId: source.externalId,
        address: source.address,
        city: source.city,
        companyId: conversions.toDocumentReferenceId(source.companyId),
        active: source.active,
        type: source.type,
        formatId: conversions.toDocumentReferenceId(source.formatId)
      }, conversions.classToDocumentId(source));
    }
  }]);

  return CompetitorSiteConverterImpl;
}(CompetitorSiteConverter_1.CompetitorSiteConverter);

exports.CompetitorSiteConverterImpl = CompetitorSiteConverterImpl;